<div class="container">
  <div class="wrapper">
    <div class="title-section">
      <ion-text class="title ion-text-start">Congelamiento de saldos</ion-text>
      <ion-text class="label ion-text-start">
        Si estás en trámite de pensión puedes transferir tus ahorros a una Cuenta Corriente del Fondo de Pensión
        <p><a class="link-conoce-mas" (click)="openInformationModal()">
            Conoce más del Congelamiento de saldos
          </a></p>
      </ion-text>
    </div>
    <div class="item-container">
      <div class="item-container-icon">
        <img src="../assets/icons/variacion-circulo.svg" slot="start" class="item-icono-svg" alt="">
      </div>
      <div class="item-text">
        <ion-text class="text-header">Evita las variaciones del mercado</ion-text>
        <ion-text class="text-description">
          Tus ahorros mantendrán su valor al ser transferidos a una Cuenta Corriente del Fondo de Pensión.
        </ion-text>
      </div>
    </div>
    <div class="item-container">
      <div class="item-container-icon">
        <img src="../assets/icons/dinero.svg" slot="start" class="item-icono-svg" alt="">
      </div>
      <div class="item-text">
        <ion-text class="text-header">Congela tus Cuentas Obligatorias y Voluntarias</ion-text>
        <ion-text class="text-description">
          Puedes solicitar el total de tus ahorros obligatorios y/o el traspaso total o parcial que desees en los voluntarios.
        </ion-text>
      </div>
    </div>
    <div class="item-container">
      <div class="item-container-icon">
        <img src="../assets/icons/badge-money.svg" slot="start" class="item-icono-svg" alt="">
      </div>
      <div class="item-text">
        <ion-text class="text-header">Cuentas que no se pueden congelar</ion-text>
        <ion-text class="text-description">
          No es posible congelar las Cuentas de Ahorro de Indemnización y de ahorro voluntario si es que no se destinan a la pensión.
        </ion-text>
      </div>
    </div>
    <div class="item-container">
      <div class="item-container-icon">
        <img src="../assets/icons/date.svg" slot="start" class="item-icono-svg" alt="">
      </div>
      <div class="item-text">
        <ion-text class="text-header">Te contactaremos para confirmar tu solicitud</ion-text>
        <ion-text class="text-description">
          Luego de esto traspasaremos tus saldos a la Cuenta Corriente del Fondo de Pensión en un plazo de 4 días
          hábiles.
        </ion-text>
      </div>
    </div>
    <button class="b-btn p-button primary-button" (click)="iniciarCongelamientoSaldos()"
      [disabled]="loading">
      Solicitar
      <div class="spinner-wrapper">
        <ion-spinner name="crescent" slot="end" color="light" *ngIf="loading"></ion-spinner>
      </div>
    </button>
  </div>

</div>
